import { Content } from "@/ui";
import { createTitle } from "@/functions/createTitle";
import { meet_the_team_helper } from "@/helpers/meet_the_team_helper";
import { consultant_helper } from "@/helpers/consultant_helper";
import { jobs_helper } from "@/helpers/jobs_helper";

export default function MeetTheTeamPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const meetTheTeamPage = meet_the_team_helper.find(url_slug);
  const members = meetTheTeamPage["members"]?.map((member) => consultant_helper.find(member, "consultant") ?? null);
  const links = meet_the_team_helper.fetch().map(({ name, url_slug }) => ({ name, url_slug }));
  const jobs = jobs_helper.fetch({
    limit: 10,
    filter: (i) => members.some((m) => (m?.email ? i.description.includes(m.email) : false)),
  });

  return {
    props: {
      meta: {
        title: createTitle("Meet the Team"),
      },
      content: [
        {
          id: "Header",
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: meetTheTeamPage.name,
          },
        },
        !!meetTheTeamPage.body && {
          id: "RichText",
          component: "RichText",
          props: {
            body: meetTheTeamPage.body ?? null,
          },
        },
        {
          id: "MeetTheTeamPanel",
          component: "MeetTheTeamPanel",
          props: {
            members: members ?? [],
            links: links,
          },
        },
        jobs.length > 0 && {
          id: "LatestJobs",
          component: "LatestJobs",
          props: {
            items: jobs,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  const includes = meet_the_team_helper.fetch().map((i) => i.id);

  return {
    paths: meet_the_team_helper.toPaths({ includes }),
    fallback: false,
  };
}
